module.exports = __webpack_public_path__ + "img/course-title2.264d8a5a.png";